import * as API from "../../api"
import * as ActionTypes from "../action-types";
import { REDUX } from '../../../constants'

import { 
    setLoadingReport, 
    unsetLoadingReport
} from './style'

/**
 * ThirdParty Library
 */
 import {
    message
} from 'antd'

export const batch_get_drivers_request = (drvids, uid) => dispatch => {

    API
    .getDriverInfoBatch(drvids)
    .then(info => {

        const {
            drivers
        } = info
        
        try {

            dispatch(batch_get_drivers_success(drivers, uid))

        } catch(err) {
            message.error('Error in batch getting vehicles. Refresh page?')
        }

    })
}

const batch_get_drivers_success = (drivers) => {
    return {
        type: ActionTypes.GET_DRIVERS,
        drivers
    };
}

 export const get_drivers_request = (vids, uid) => dispatch => {

    let vidBatch = []

    vids.map((vid, index) => {

        vidBatch.push(vid)

        if( 
            (index+1) % REDUX.REDUX_VEHICLE_BATCH_GET_SIZE === 0
            ||
            index+1 === vids.length
        ) {
            dispatch(batch_get_drivers_request(vidBatch, uid))
            vidBatch = []
        }

        return null
    })
 }

export const create_driver_request = (items, cb = () => {}) => dispatch => {
    API
    .cuDriver({
        ...items,
        action: 'C'
    })
    .then(info => {
        const { driver, status, msg } = info

        if(status === 200) {
            dispatch(create_driver_success(driver))
            message.success(msg)
            cb()
        } else {
            message.warning('Failed in updating driver. Retry?')
        }

    })
    // .finally(() => {
    //     cb()
    // })
}

const create_driver_success = (driver) => {
    return {
        type: ActionTypes.CREATE_DRIVER,
        driver
    }
}

export const get_driver_performance_dashboard_data_request = items => dispatch => {

    dispatch(setLoadingReport())

    API
    .getDriverPerformanceDashboard(items)
    .then(info => {

        const { status, msg, driverScoreLog, driverSummaryCurMonth, driverSummaryPrevMonth, topEvents } = info

        if(status === 200) {
            dispatch(get_driver_performance_dashboard_data_success(driverScoreLog, driverSummaryCurMonth, driverSummaryPrevMonth, topEvents))
            message.success(msg)
        } else {
            message.warning(msg)
        }
    })
    .finally(() => {
        dispatch(unsetLoadingReport())
    })
}

const get_driver_performance_dashboard_data_success = (driverScoreLog, driverSummaryCurMonth, driverSummaryPrevMonth, topEvents) => {
    return {
        type: ActionTypes.GET_DRIVER_PERFORMANCE_DASHBOARD_DATA,
        driverScoreLog, driverSummaryCurMonth, driverSummaryPrevMonth, topEvents
    }
}

export const set_schedule_pretrip_search_request = items => dispatch => {
    dispatch(set_schedule_pretrip_search_success(items.drvid, items.startTime, items.endTime))
}

const set_schedule_pretrip_search_success = (drvid, startTime, endTime) => {
    return {
        type: ActionTypes.SET_SCHEDULE_PRETRIP_SEARCH,
        drvid, startTime, endTime
    }
}

export const create_schedule_pretrip_request = items => dispatch => {

    API
    .createDriverSchedule(items)
    .then(info => {

        const { status, msg, driverSchedule } = info

        if(status === 200) {
            message.success(msg)
            dispatch(create_schedule_pretrip_success(driverSchedule))
        } else {
            message.warning(msg)
        }
    })
}

const create_schedule_pretrip_success = (driverSchedule) => {
    return {
        type: ActionTypes.CREATE_SCHEDULE_PRETRIP,
        driverSchedule
    }
}


export const create_drivers_request = (items) => dispatch => {

    API
    .createDrivers(
        items
    )
    .then(info => {

        const { status, driver, msg } = info

        if(status === 200) {
            dispatch(create_drivers_success(driver))
            message.success(msg)
        } else {
            message.error('Failed in creating bulk drivers. Retry? Error: ' + msg)
        }
    })

}

const create_drivers_success = (drivers) => {
    return {
        type: ActionTypes.CREATE_DRIVERS,
        drivers
    }
}

export const update_driver_request = (items, cb = () => {}) => dispatch => {

    delete items.key

    API
    .cuDriver({
        ...items,
        action: 'U'
    })
    .then(info => {
        const { status, driver, msg } = info

        if(status === 200) {
            dispatch(update_driver_success(driver))
            message.success(msg)
        } else {
            message.warning('Failed in updating driver. Retry?')
        }
    })
    .finally(() => {
        cb()
    })
}

const update_driver_success = (driver) => {
    return {
        type: ActionTypes.UPDATE_DRIVER,
        driver
    }
}

export const get_driver_request = (drvid, cb = () => {}) => {

    API
    .getDriverInfoBatch([drvid])
    .then(info => {

        const {
            drivers,
            status
        } = info

        if(status === 200) {
            cb(drivers)
        } else {
            message.error('No driver matched!')
        }

    })
}

export const get_incidents_report_thru_drvids_request = (items, cb = () => {}) => dispatch => {

    dispatch(setLoadingReport())

    API
    .getIncidentReport(items)
    .then(info => {
        const { status, report, msg } = info

        if(status === 200) {
            dispatch(get_incidents_report_thru_drvids_success(report))
            cb()
            message.success(msg)
        } else {
            message.warning('Failed in get incidents report. Retry?')
        }
    })
    .finally(() => {
        // cb()
        dispatch(unsetLoadingReport())
    })
}

const get_incidents_report_thru_drvids_success = (reports) => {
    return {
        type: ActionTypes.GET_INCIDENT_REPORT_THRU_DRVIDS,
        reports
    }
}


export const create_incident_report_request = (items, cb = () => {}) => dispatch => {

    dispatch(setLoadingReport())

    API
    .createIncidentReport(items)
    .then(info => {
        const { status, driverState, incident, msg } = info

        if(status === 200) {
            dispatch(create_incident_report_success({ ...driverState, ...incident }))
            cb()
            message.success(msg)
        } else {
            message.warning('Failed in creating incident report. Retry?')
        }
    })
    .finally(() => {
        // cb()
        dispatch(unsetLoadingReport())
    })
}

const create_incident_report_success = (reports) => {
    return {
        type: ActionTypes.CREATE_INCIDENT_REPORT,
        reports: [reports],
        mode: 'incident'
    }
}

export const update_incident_report_request = (items, cb = () => {}) => dispatch => {

    API
    .updateIncidentReport(items)
    .then(info => {
        const { status, driverState, incident, msg } = info

        if(status === 200) {
            dispatch(update_incident_report_success({...driverState, ...incident}))
            cb()
            message.success(msg)
        } else {
            message.warning('Failed in updating incident report. Retry?')
        }
    })
    .finally(() => {
        // cb()
    })
}

const update_incident_report_success = (reports) => {
    return {
        type: ActionTypes.UPDATE_INCIDENT_REPORT,
        reports
    }
}

export const get_driver_session_request = (drvid, cb = () => {}) => {
    API
    .getDriverSession(drvid)
    .then(info => {

        const { driverSession } = info

        cb(driverSession)
    })
}

/**
 * Pre-trip
 */

export const create_driver_pretip_request = (items, cb = () => {}) => () => {
    API
    .createDriverPretip(items)
    .then(info => {

        const { status, msg } = info
        
        if(status === 200) {
            message.success('Checklist Submitted Successfully!')
            cb()
            console.log(info)
        } else {
            message.error(msg)
        }
    })
}


export const get_driver_pretip_by_drvid_request = (items) => dispatch => {
    dispatch(setLoadingReport())

    API
    .getDriverPretipByDRVID(items)
    .then(info => {

        const { status, driverPretrip, driverSchedules } = info

        if(status === 200) {
            dispatch(get_driver_pretip_by_drvid_success(driverPretrip, driverSchedules, items.drvid, items.startTime, items.endTime))
        } else {
            message.error('Failed in getting Driver Pretrip. Retry?')
        }
    })
    .finally(() => {
        dispatch(unsetLoadingReport())
    })
}

const get_driver_pretip_by_drvid_success = (driverPretrip, driverSchedules, drvid, startTime, endTime) => {
    return {
        type: ActionTypes.GET_DRIVER_PRETRIP_RECORDS_BY_DRVID,
        driverPretrip,
        driverSchedules,
        drvid,
        startTime, endTime
    }
}

export const get_all_driver_checklist_request = () => dispatch => {
    // dispatch(setLoadingReport())

    API
    .getAllDriverChecklistItem()
    .then(info => {

        const { status, driverChecklistItems } = info

        if(status === 200) {
            dispatch(get_all_driver_checklist_success(driverChecklistItems))
        } else {
            message.error('Error in gettling all driver checklist')
        }
    })
    // .then(() => {
    //     dispatch(unsetLoadingReport())
    // })
}

export const get_driver_by_ic_number_request = (icNumber, cb = () => {}) => () => {
    // dispatch(setLoadingReport())

    API
    .getDriverByICNumber(icNumber)
    .then(info => {

        const { status, driverInfo } = info

        if(status === 200) {
            cb(driverInfo)
        } else {
            message.error('IC does not match with any driver!')
        }
    })
    // .then(() => {
    //     dispatch(unsetLoadingReport())
    // })
}

const get_all_driver_checklist_success = (driverChecklistItems) => {
    return {
        type: ActionTypes.GET_ALL_DRIVER_PRETRIP_CHECKLIST,
        driverChecklistItems
    }
}

export const set_driver_pretrip_filter_success = (filters) => {
    return {
        type: ActionTypes.SET_DRIVER_PRETRIP_FILTER,
        filters
    }
}